




































  import {Component, Vue, Prop, Watch, Emit} from "vue-property-decorator";
  import "./project-gallery-destop.less";


  @Component({
      components: {
      }
  })
  export default class ProjectGalleryDestop extends Vue {
      @Prop() images;
      @Prop() galleryNumber;
      @Prop() isMobile;
      private data ={
          'index' :0,
          'visible' :false,
          'images': []
      };
      private ratios={
          a_16_9: {
              height:9/16,
              bigHeight:9/16,
              imgRatio: 16/9,
              bigImgRatio: 16/9,
          },
          a_1_4: {
              height:1,
              bigHeight:0.677,
              imgRatio: 1,
              bigImgRatio: 1.4769,
          },
      };
      /*
      ratios style:
          a_16_9: 1 nagy elem és mellette 2 kis elem mindegyik 16:9-es arányban megjelenítve
          a_1_4: 1 nagy elem és mellette 4 kis elem 2 oszlopban a nagy 0.677-es arányú a kicsik 1-es arányúak
      */
      private useRatio = 'a_1_4';
      mounted() {
          if(this.isExist(this.images)){
              this.data.images = this.images;
          }
          let self = this;
          setTimeout(function () {
              self.initGaleryView();
          }, 200);
          $(window).resize(this.initGaleryView)
      }

      initGaleryView(){
          let self = this;
           $('#project-images-galery-'+this.galleryNumber).find('.project-image-container .widescreen').each(function (i, e) {
              let elem: any= $(e);
              let width: any= elem.width();
              if (elem.hasClass('big'))
                  elem.height(width * self.ratios[self.useRatio].bigHeight);
              else {
                  const big = $('#project-images-galery-'+self.galleryNumber).find('.big');
                  const height = big!.height();
                  elem!.height(height! / 2 - 2.5);
                  }
           })
          $('#project-images-galery-'+this.galleryNumber).find('.project-image-container').addClass('visible');
      }

      //imgRatio = 1.33;//16 / 9;  //1 a 4-es elrendezés miatt

      loaded(ev) {
          const img = $(ev.target);
          if (img.length) {
              let imgRatio = img.closest('.big') ? this.ratios[this.useRatio].bigImgRatio : this.ratios[this.useRatio].imgRatio;
              /*console.log(img.get(0));
              console.log(img.get(0).naturalWidth! / img.get(0).naturalHeight! < imgRatio
                  ? "narrow"
                  : "wide");*/
          img
              .eq(0)
              .addClass(
              img.get(0).naturalWidth! / img.get(0).naturalHeight! < imgRatio
                  ? "narrow"
                  : "wide"
              );
          }
}

      isExist(attributes :any){
          if(attributes == null || typeof attributes == undefined){
              return false;
          } else {
              return true;
          }
      }

      @Emit("showModalGallery")
      onShowModalGallery(index, visible){
      }

      @Watch("images", { immediate: true, deep: true })
      onImages(images) {
          let self = this;
          this.data.images = images;
          setTimeout(function(){
              self.initGaleryView();
          },300);
          
      }

  }
